import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 21 26"

const BagIconFilled = createSvgIcon(
  <>
    <g id='Header---AE-Only'>
      <g id='_x31_024---PTP' transform='translate(-967 -59)'>
        <g id='Utility-Nav' transform='translate(723 59)'>
          <g id='Bag' transform='translate(244)'>
            <path
              id='Shape'
              d='M20.5 6.3c-.2-.2-.3-.2-.6-.2h-4.5V4.9c0-2.7-2.3-4.9-5-4.9s-5 2.2-5 4.9V6H.8c-.2 0-.4.1-.6.2-.1.3-.2.5-.2.7l1.1 14.9c.2 2.3 2.1 4 4.4 4H15c2.3 0 4.2-1.8 4.4-4l1.3-15c0-.1-.1-.3-.2-.5zM6.2 4.9c0-2.2 1.8-4 4.1-4s4.1 1.8 4.1 4V6H6.2V4.9z'
            />
          </g>
        </g>
      </g>
    </g>
  </>,
  'BagIconFilled'
)

export default BagIconFilled
